import { EPaletteModes, ThemePack } from '@/types/theme-packs.types';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import styles from './theme-pack-secondary-color-type.module.css';
import isColorLightOrDark from '@/utils/colors/is-color-light-or-dark';
import Button from '@ui/buttons/button/button';

type TThemePackCreationTypeProps = {
  themePack?: ThemePack;
  themeMode: EPaletteModes;
  selectTab: () => void;
  active: boolean;
  disabled?: boolean;
};

const lightClass = (color: string) => {
  if (isColorLightOrDark(color) === EPaletteModes.Light) {
    return styles.light;
  }

  return styles.dark;
};

const ThemePackSecondaryColorButton = ({
  disabled,
  themePack,
  selectTab,
  active,
  themeMode,
}: TThemePackCreationTypeProps) => {
  if (!themePack) return null;
  const colors = themePack.colors[themeMode] ?? themePack.colors;
  return (
    <>
      <Container
        background={active ? 'var(--gray-100)' : 'var(--gray-700)'}
        transitionDuration="0.2s"
        borderRadius="100px"
        height="32px"
        padding="2px"
        className="flex ai-center jc-space-between"
      >
        <Button
          clear
          backgroundColor={active ? 'var(--gray-900)' : 'var(--gray-700)'}
          hoverBackgroundColor="var(--gray-800)"
          className="flex ai-center gap-6 width-100-percent jc-space-between padding-l-8 padding-r-8"
          height={'28px'}
          borderRadius="100px"
          disabled={disabled}
          onClick={selectTab}
        >
          <Container background="transparent" className="flex ai-center gap-6">
            <Text color="var(--gray-300)" className="C1" whiteSpace="nowrap">
              Secondary
            </Text>
            <Container className="flex padding-r-6">
              <div
                className={`square-20 radius-full margin-r--8 ${styles.colorBubble} ${lightClass(colors.secondaryBackgroundColor[0])}`}
                style={{
                  backgroundColor: colors.secondaryBackgroundColor[0],
                }}
              ></div>
              <div
                className={`square-20 radius-full margin-r--8 ${styles.colorBubble} ${lightClass(colors.backgroundColor[0])}`}
                style={{ backgroundColor: colors.backgroundColor[0] }}
              ></div>
              <div
                className={`square-20 radius-full margin-r--8 ${styles.colorBubble} ${lightClass((colors.buttonTextColor ?? colors.bodyTextColor)[0])}`}
                style={{ backgroundColor: (colors.buttonTextColor ?? colors.bodyTextColor)[0] }}
              ></div>
              <div
                className={`square-20 radius-full margin-r--8 ${styles.colorBubble} ${lightClass(colors.headingTextColor[0])}`}
                style={{ backgroundColor: colors.headingTextColor[0] }}
              ></div>
              <div
                className={`square-20 radius-full ${styles.colorBubble} ${lightClass(colors.bodyTextColor[0])}`}
                style={{ backgroundColor: colors.bodyTextColor[0] }}
              ></div>
            </Container>
          </Container>
        </Button>
      </Container>
    </>
  );
};

export default ThemePackSecondaryColorButton;
